const capitalizedInLease = (vehicle) => {
  const incentives = vehicle?.incentives || [];
  const usedEv = vehicle?.available_for_purchase_as_used;

  const filteredIncentives = incentives.filter((incentive) =>
    usedEv
      ? incentive.applicable_to_used_vehicles
      : incentive.applicable_to_new_vehicles &&
        (!incentive.evaluation ||
          incentive.evaluation.eligibility !== 'ineligible')
  );

  let totalSavings = 0;
  filteredIncentives.forEach((incentive) => {
    const amount = incentive.evaluation?.amount_in_lease || 0;
    totalSavings += amount;
  });

  return totalSavings;
};

export default capitalizedInLease;
